<template>
  <!-- 查看详情 -->
  <div>
    <div class="comInfo">
      <div class="rowB">
        <div class="body">
          <div class="topTitle">{{ info.title }}</div>
          <div class="littleTitle">
            <span>发布日期：{{ info.showTime }}</span>
            <span style="margin-left:5px">信息来源：{{ info.source }}</span>
            <span style="margin-left:5px">阅读次数：{{ info.hits }}</span>
          </div>
          <div style="width:100%; display:flex;flex-direction: row-reverse;" v-if="info.isUrl">
            <div class="card_btn" @click="handleOpen(info.outUrl)">预订</div>
          </div>
          <div class="line"></div>
          <div class="leftBody">
            <img :src="info.url" align="left" class="commonImg" v-show="info.url != null" style="margin-right:13px" />
            <div v-html="info.details" class="leftBodyFont">
              {{ info.details }}
            </div>
          </div>
        </div>
      </div>
      <!-- //返回 -->
      <div class="public-back-btn">
        <img src="@/assets/image/videoback.png" style="width:5vh;height:5vh;cursor:pointer;" @click="handleBack" />
      </div>
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:1.018vh;">武夷山景区</div>
            <div style="margin-top:1.018vh;">天下难寻</div>
            <div style="margin-top:1.018vh;">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/css/details.css";
export default {
  props: {
    info: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    handleOpen(e) {
      window.open(e);
    },
    handleBack() {
      this.$emit('closed');
    }
  }
};
</script>

<style scoped>
.card_btn {
  width: 63px;
  height: 20px;
  background: #ffffff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 12px;
  color: #449088;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/outline/detailsInfo.vue